import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { updateCompanyAdminEmploye, resetCompanyAdminEmployeData } from "Services/action";
import Button from '@material-tailwind/react/Button';
import loader from "assets/img/loading.gif";
import WebLogo from 'assets/img/logo.png';
import BridgeLogo from 'assets/img/bridge.jpg';
import StGeorge from 'assets/img/st-george.jpeg';
import Hume from 'assets/img/Hume.jpeg';
import LinkWentworth from 'assets/img/LinkWentworth.jpeg';
import NswLandHouse from 'assets/img/NswLandHouse.jpeg';


import { useDispatch, useSelector } from "react-redux";
    const EmployeCard = ({ employeData, onClose }) => {
        const dispatch = useDispatch();
    const location = useLocation();
    const employeDetail = employeData;
    const [loading, setLoading] = useState(false);

    const [base64Image, setBase64Image] = useState('');
    const [logoImg, setlogoImg] = useState();
    const handleImageChange = (e) => {
        setlogoImg(URL.createObjectURL(e.target.files[0]));

        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setBase64Image(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();


    function onSubmit(employeData) {
        employeData.id = employeDetail?.id;
        employeData.company_id = employeDetail?.company_id;
        employeData.profileImage = base64Image;

        if (employeData?.phone_no.startsWith("61")) {
            employeData.phone_no = employeData.phone_no.slice(2);
            employeData.phone_no = employeData.phone_no.padStart(10, '0');
      }

        dispatch(updateCompanyAdminEmploye(employeData));
        dispatch(resetCompanyAdminEmployeData());
        onClose(employeData);
    }
    const companyAdminData = useSelector((state) => state?.CompanyAdminDetail?.companyAdminDetailRec);
    return (

        <div className="modal fixed inset-0 flex items-center justify-center bg-white bg-opacity-30 z-50">
  <div className="modal-content relative p-4 bg-white rounded shadow-lg max-w-md w-full">
  <button
      className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
      onClick={() => onClose(null)}
      aria-label="Close"
    >
      Close
    </button>
    <div className="text-purple-700 font-bold text-center mb-2">
    {companyAdminData && companyAdminData?.name} - ID Card
    </div>
    <div className="border rounded shadow p-4 mb-4">
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <img src={companyAdminData && companyAdminData?.companyLogo ? companyAdminData?.companyLogo : WebLogo} alt={companyAdminData && companyAdminData?.name} className="h-10 mb-2" />
          <div className="font-semibold text-lg">{employeDetail?.name} {employeDetail?.lastname}</div>
          <div className="text-sm mb-1">{employeDetail?.role}</div>
          <div className="text-sm">Ph: {employeDetail?.phone_no}</div>
          <div className="text-sm">Lic No: {companyAdminData && companyAdminData?.license}</div>
          <div className="text-xs mt-2">
            Contractor/Employee on behalf of {companyAdminData && companyAdminData?.name}
          </div>
        </div>
        <div className="flex-shrink-0 ml-4 text-sm">
          <div className="font-semibold mb-2">Card No: {employeDetail?.card_no}</div>
          {employeDetail?.profileImage ? <img src={employeDetail?.profileImage} alt="Profile" className="w-24 h-28 object-cover rounded" />: null}
        </div>
      </div>
    </div>

    <div className="text-center text-green-600 text-xl font-semibold mb-4">
      PM <span className="text-3xl">12</span> : <span className="text-3xl">23</span><span className="text-sm">56</span>
    </div>

    <div className="border rounded shadow p-4">
      <div className="text-center font-semibold mb-4">
        Authorised Contractor for
      </div>
      <div className="grid grid-cols-3 gap-4 items-center justify-items-center">
        <img src={BridgeLogo ? BridgeLogo : WebLogo} alt="" className="h-8" />
        <img src={StGeorge ? StGeorge : WebLogo} alt="" className="h-8" />
        <img src={Hume ? Hume : WebLogo} alt="" className="h-8" />
        <img src={LinkWentworth ? LinkWentworth : WebLogo} alt="" className="h-8" />
        <img src={NswLandHouse ? NswLandHouse : WebLogo} alt="" className="h-8" />
      </div>
    </div>
  </div>
</div>



       
    );
};

export default EmployeCard;
